export default (rawDate: string | null): Date | undefined => {
  if (rawDate == null) {
    return undefined;
  }
  const date = Date.parse(rawDate);
  return Number.isNaN(date) ? undefined : new Date(date);
};
